var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgUfoTelescope(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 160.351,
    height: 156.97,
    viewBox: "0 0 160.351 156.97",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ufo_telescope",
    transform: "translate(-29.113 -4296)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_43972",
    "data-name": "Path 43972",
    d: "M83.339,4460.68a2.243,2.243,0,0,1-1.024-3l24.554-49.586a7.408,7.408,0,0,0,1.44,2.133Z",
    transform: "translate(-4.952 -10.478)",
    fill: "#c09342"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_43973",
    "data-name": "Path 43973",
    d: "M110.263,4411.828l-23.793,48.049a2.243,2.243,0,0,1-3,1.023l24.97-50.456A7.4,7.4,0,0,0,110.263,4411.828Z",
    transform: "translate(-5.081 -10.698)",
    fill: "#f9f9f9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_43974",
    "data-name": "Path 43974",
    d: "M124.174,4408.091l24.554,49.586a2.243,2.243,0,0,1-1.023,3l-24.971-50.456A7.372,7.372,0,0,0,124.174,4408.091Z",
    transform: "translate(-8.752 -10.478)",
    fill: "#c09342"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_43975",
    "data-name": "Path 43975",
    d: "M147.517,4460.9a2.244,2.244,0,0,1-3-1.023l-23.792-48.049a7.4,7.4,0,0,0,1.824-1.384Z",
    transform: "translate(-8.564 -10.698)",
    fill: "#f9f9f9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_43976",
    "data-name": "Path 43976",
    d: "M122.878,4407.923a7.382,7.382,0,0,1-4.51,4.043v-.45a2.243,2.243,0,1,0-4.486,0v.45a7.3,7.3,0,0,1-1.245-.526,7.448,7.448,0,0,1-3.265-3.517,7.316,7.316,0,0,1-.509-1.628h14.523A7.317,7.317,0,0,1,122.878,4407.923Z",
    transform: "translate(-7.455 -10.311)",
    fill: "#e2e0e2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_43977",
    "data-name": "Path 43977",
    d: "M116.643,4382.3a5.215,5.215,0,0,0-2.244.51v-3.565q1.119-.547,2.244-1.1Z",
    transform: "translate(-7.973 -7.679)",
    fill: "#f7f7f7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_43978",
    "data-name": "Path 43978",
    d: "M115.891,4401.826h7.885a1.646,1.646,0,1,1,0,3.292H108.005a1.646,1.646,0,1,1,0-3.292h5.642v-8.116a5.2,5.2,0,0,0,2.244.51Z",
    transform: "translate(-7.221 -9.134)",
    fill: "#f7f7f7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_43979",
    "data-name": "Path 43979",
    d: "M116.334,4378.026q1.123-.557,2.243-1.117v5.788a5.223,5.223,0,0,1,0,9.442v8.116h-2.243v-7.606a5.232,5.232,0,0,1,0-10.464Zm-3.348,9.392a3.347,3.347,0,1,0,3.348-3.347A3.347,3.347,0,0,0,112.987,4387.418Z",
    transform: "translate(-7.664 -7.564)",
    fill: "#f9f9f9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_43980",
    "data-name": "Path 43980",
    d: "M119.876,4388.157a3.347,3.347,0,1,1-3.347-3.347A3.347,3.347,0,0,1,119.876,4388.157Zm-2.7-.5c.551.809,1.285,1.272,1.639,1.031s.194-1.093-.357-1.9-1.285-1.272-1.639-1.031S116.626,4386.844,117.177,4387.655Z",
    transform: "translate(-7.859 -8.302)",
    fill: "#b58539"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_43981",
    "data-name": "Path 43981",
    d: "M118.815,4386.873c.551.811.711,1.663.357,1.9s-1.088-.222-1.639-1.031-.711-1.664-.357-1.9S118.264,4386.063,118.815,4386.873Z",
    transform: "translate(-8.215 -8.393)",
    fill: "#c09342"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_43982",
    "data-name": "Path 43982",
    d: "M32.031,4392.077l0-.007.1-.057c.021-.013.038-.027.059-.039s.046-.02.069-.033l17.708-9.9,0,.006c-3,2.068-3.563,6.926-1.186,11.155.005.01.012.018.017.028l.014.026c2.483,4.417,7.223,6.463,10.589,4.572l-18.192,10.19c-3.365,1.892-8.106-.155-10.589-4.571l-.014-.027-.018-.029C28.149,4399.053,28.807,4394.041,32.031,4392.077Z",
    transform: "translate(0 -8.044)",
    fill: "#f9f9f9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_43983",
    "data-name": "Path 43983",
    d: "M69.438,4382.659l-9.014,5.067-3.012,1.693h0l0,0c-1.257-2.238-1.594-4.436-.751-4.909,0,0,1.476-.876,3.636-2.155,2-1.183,4.579-2.709,7.136-4.215a25.074,25.074,0,0,0,2.006,4.519Z",
    transform: "translate(-2.531 -7.678)",
    fill: "#e2e0e2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_43984",
    "data-name": "Path 43984",
    d: "M50.69,4393.162l-.014-.026c-.005-.01-.012-.018-.017-.028-2.377-4.228-1.817-9.086,1.186-11.154.135-.093.267-.188.412-.269,2.211-1.243,5.013-.778,7.382.935-2.16,1.278-3.636,2.155-3.636,2.155-.843.473-.507,2.671.751,4.909l0,0h0l.029.052c1.257,2.237,2.96,3.667,3.8,3.193.7-.32,2.049-1.014,3.736-1.906.206,2.88-.854,5.478-3.044,6.71C57.914,4399.625,53.173,4397.58,50.69,4393.162Z",
    transform: "translate(-1.876 -7.944)",
    fill: "#f7f7f7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_43985",
    "data-name": "Path 43985",
    d: "M57.566,4389.938l-.029-.052h0l3.012-1.693,9.014-5.067a24.943,24.943,0,0,0,2.89,4.146c-2.582,1.4-5.232,2.836-7.349,3.954-1.687.892-3.038,1.586-3.736,1.906C60.526,4393.6,58.823,4392.175,57.566,4389.938Z",
    transform: "translate(-2.657 -8.145)",
    fill: "#b58539"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_43986",
    "data-name": "Path 43986",
    d: "M70.521,4380.893a25.063,25.063,0,0,1-2.006-4.519c-1.026-3.178-.984-5.757.323-6.492,0,0,9.292-5.789,17.29-10.62a20.844,20.844,0,0,0,.5,2.711c-9.879,6.36-16.057,11.009-15.526,11.928.516.894,7.254-1.939,17.234-7.04.458,1.035.981,2.083,1.57,3.132a36.091,36.091,0,0,0,2.778,4.231l-16.268,9.145h0l-2.994,1.683-.013-.012a24.943,24.943,0,0,1-2.89-4.146Z",
    transform: "translate(-3.616 -5.914)",
    fill: "#f7f7f7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_43987",
    "data-name": "Path 43987",
    d: "M77,4384.912l16.268-9.145a25.172,25.172,0,0,0,4.431,4.583l-.023.012.048.036c-6.3,3.354-14.081,7.43-18.061,9.252-1.3.73-3.5-.551-5.67-3.048L74,4386.6,77,4384.912Z",
    transform: "translate(-4.195 -7.457)",
    fill: "#f9f9f9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_43988",
    "data-name": "Path 43988",
    d: "M112.963,4354.1q.691,1.4,1.479,2.815a53.176,53.176,0,0,0,6.5,9.211l-13.395,7.531h0l-8.308,4.67a25.141,25.141,0,0,1-4.431-4.583,36.084,36.084,0,0,1-2.778-4.23c-.589-1.049-1.112-2.1-1.57-3.132,1.832-.937,3.777-1.952,5.811-3.033C101.361,4360.638,107.02,4357.509,112.963,4354.1Z",
    transform: "translate(-5.735 -5.431)",
    fill: "#e2e0e2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_43989",
    "data-name": "Path 43989",
    d: "M110.267,4346.868c-6.16,3.566-11.917,7.03-16.98,10.193q-2.507,1.567-4.775,3.027h0a20.855,20.855,0,0,1-.5-2.711c-.351-3.107.241-5.484,1.861-6.4,0,0,9.238-6.19,18.514-11.889a37.185,37.185,0,0,0,1.885,7.775Z",
    transform: "translate(-5.496 -4.028)",
    fill: "#e2e0e2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_43990",
    "data-name": "Path 43990",
    d: "M100.141,4379.565l8.308-4.67h0l13.395-7.531a35.357,35.357,0,0,0,4.424,4.233c-2.669,1.369-5.659,2.892-8.717,4.42l-2.243,1.117q-1.123.555-2.244,1.1c-2.221,1.089-4.41,2.145-6.469,3.109-1.619.911-3.959.179-6.429-1.735l-.048-.036Z",
    transform: "translate(-6.638 -6.671)",
    fill: "#b58539"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_43991",
    "data-name": "Path 43991",
    d: "M122.8,4360.869a53.176,53.176,0,0,1-6.5-9.211q-.791-1.41-1.479-2.815l1.408-.81q3.851-2.224,7.478-4.384c18.128-10.787,31.294-19.859,30.529-21.185s-15.173,5.525-33.549,15.812q-3.7,2.073-7.6,4.319l-.725.42a37.181,37.181,0,0,1-1.885-7.775c-.583-4.881.323-8.624,2.854-10.047,0,0,26.783-17.951,43.812-27.3-5,2.809-3.156,15.567,4.112,28.5a57.4,57.4,0,0,0,10.557,13.838l-31.566,17.745-12.985,7.111a16.055,16.055,0,0,0,6.555,3.367,15.3,15.3,0,0,1-6.6-3.345A35.321,35.321,0,0,1,122.8,4360.869Z",
    transform: "translate(-7.59 -0.177)",
    fill: "#f7f7f7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_43992",
    "data-name": "Path 43992",
    d: "M193.15,4336.114l-.125.071c.118-.147.237-.294.349-.446l.045.224-.269.151Z",
    transform: "translate(-15.323 -3.715)",
    fill: "#f9f9f9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_43993",
    "data-name": "Path 43993",
    d: "M180.928,4318.889c.924,1.644,1.749,3.267,2.466,4.831a7.583,7.583,0,0,1-1.974,2.22,7.976,7.976,0,0,1,2.565,3.368,9.039,9.039,0,0,1,.992-1.767c1.226,3.343,1.81,6.17,1.631,7.983l.035-.02a1.949,1.949,0,0,1-3.2,1.8h0l.565-.317-.529.3c-2.943-1.413-7.4-6.626-11.262-13.5-5.013-8.917-7.125-17.243-4.718-18.6S175.915,4309.972,180.928,4318.889Zm4.543,17.275-.431.243Z",
    transform: "translate(-12.843 -0.842)",
    fill: "#916a2c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_43994",
    "data-name": "Path 43994",
    d: "M141.994,4357.913l31.566-17.745A57.414,57.414,0,0,1,163,4326.329c-7.268-12.929-9.11-25.687-4.112-28.5,2.8-1.577,7.163.314,11.735,4.56a16.747,16.747,0,0,0-6.638,2.078c-2.407,1.354-.295,9.679,4.718,18.6,3.863,6.872,8.318,12.085,11.262,13.5l.529-.3-.565.317h0l-6.386,3.591c4.556,4.22,8.9,6.1,11.7,4.532,0,0-26.778,14.178-46.1,23.238a5.216,5.216,0,0,1-3.58.444,16.049,16.049,0,0,1-6.555-3.367Z",
    transform: "translate(-9.338 -0.12)",
    fill: "#f9f9f9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_43995",
    "data-name": "Path 43995",
    d: "M178.139,4343.793l6.386-3.59a2.418,2.418,0,0,0,2.24.233,16.7,16.7,0,0,0,4.993-4.3h0l.269-.151.014-.008c1.236,6.086.587,10.777-2.207,12.348S182.7,4348.013,178.139,4343.793Z",
    transform: "translate(-13.931 -3.737)",
    fill: "#d1d1d1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_43996",
    "data-name": "Path 43996",
    d: "M190.773,4333.038a16.7,16.7,0,0,1-4.993,4.3,2.417,2.417,0,0,0,.965-2.035l-.035.02c.18-1.813-.405-4.641-1.631-7.983a7.46,7.46,0,0,1,1.573-1.6,7.971,7.971,0,0,1-2.564-3.386,9.646,9.646,0,0,1-.591,1.166c-.717-1.564-1.542-3.187-2.466-4.831-5.013-8.917-11.029-15.048-13.436-13.7a16.746,16.746,0,0,1,6.638-2.078,17.4,17.4,0,0,1,5.275.311c-.079.062-.152.126-.233.188a15.964,15.964,0,0,1,5.13,6.738,17.777,17.777,0,0,1,2.149-3.765,19.282,19.282,0,0,1,5.435,6.142,18.568,18.568,0,0,1-.992,20.137c-.112.151-.231.3-.349.446Z",
    transform: "translate(-12.945 -0.639)",
    fill: "#b58539"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_43997",
    "data-name": "Path 43997",
    d: "M193.163,4336.153h0Z",
    transform: "translate(-15.336 -3.754)",
    fill: "#b58539"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_21",
    "data-name": "Line 21",
    x1: 0.431,
    y2: 0.243,
    transform: "translate(172.197 4335.322)",
    fill: "none",
    stroke: "#b58539",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_43998",
    "data-name": "Path 43998",
    d: "M88.678,4367.141c-9.98,5.1-16.718,7.934-17.234,7.04-.531-.919,5.647-5.568,15.526-11.928h0A30.274,30.274,0,0,0,88.678,4367.141Z",
    transform: "translate(-3.954 -6.193)",
    fill: "#e5e5e5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_43999",
    "data-name": "Path 43999",
    d: "M93.349,4357.863c5.063-3.163,10.82-6.626,16.98-10.193a52.857,52.857,0,0,0,2.458,5.826c-5.943,3.412-11.6,6.541-16.694,9.248-2.033,1.081-3.979,2.1-5.811,3.034a30.274,30.274,0,0,1-1.708-4.888Q90.837,4359.432,93.349,4357.863Z",
    transform: "translate(-5.558 -4.83)",
    fill: "#e5e5e5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_44000",
    "data-name": "Path 44000",
    d: "M112.573,4345.534c.242-.14.481-.28.725-.42q3.885-2.243,7.6-4.32c18.376-10.286,32.785-17.135,33.549-15.812s-12.4,10.4-30.529,21.185q-3.62,2.154-7.478,4.384l-1.408.81a52.857,52.857,0,0,1-2.458-5.826Z",
    transform: "translate(-7.802 -2.694)",
    fill: "#e5e5e5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_44001",
    "data-name": "Path 44001",
    d: "M119.117,4411.823v49.521a2.244,2.244,0,0,1-2.243,2.244v-54.009A2.243,2.243,0,0,1,119.117,4411.823Z",
    transform: "translate(-8.204 -10.618)",
    fill: "#f9f9f9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_44002",
    "data-name": "Path 44002",
    d: "M116.643,4409.579v54.009a2.244,2.244,0,0,1-2.244-2.244v-49.521A2.244,2.244,0,0,1,116.643,4409.579Z",
    transform: "translate(-7.973 -10.618)",
    fill: "#f7f7f7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_44003",
    "data-name": "Path 44003",
    d: "M180.479,4302.772c.081-.062.154-.126.233-.188a16.034,16.034,0,0,0,4.9-6.584,15.941,15.941,0,0,0,5.128,6.772,14.868,14.868,0,0,0-2.98,2.973,17.777,17.777,0,0,0-2.149,3.765A15.964,15.964,0,0,0,180.479,4302.772Z",
    transform: "translate(-14.15)",
    fill: "#f4e192"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_44004",
    "data-name": "Path 44004",
    d: "M202.907,4315.508a3.507,3.507,0,0,1,0,6.755,3.506,3.506,0,0,1,0-6.755Z",
    transform: "translate(-16.007 -1.824)",
    fill: "#f4e192"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_44005",
    "data-name": "Path 44005",
    d: "M182.958,4327.75a7.583,7.583,0,0,0,1.974-2.22,9.646,9.646,0,0,0,.591-1.166,7.974,7.974,0,0,0,2.564,3.386,7.447,7.447,0,0,0-1.573,1.6,9.039,9.039,0,0,0-.992,1.767A7.976,7.976,0,0,0,182.958,4327.75Z",
    transform: "translate(-14.382 -2.651)",
    fill: "#f4e192"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUfoTelescope);
export default __webpack_public_path__ + "static/media/ufo_telescope.a46506f33d6aa49af4ccefd46aa9a23e.svg";
export { ForwardRef as ReactComponent };